import { Country } from '../countries/countries.interfaces';
import { Language } from '../languages/languages.interfaces';

/**
 * User interface
 */
export interface User {
  id?: number;
  firstname?: string;
  lastname?: string;
  fullName?: string;
  streetNr?: string;
  postalCode?: string;
  city?: string;
  telephone?: string;
  email: string;
  confirmed?: boolean;
  activated?: boolean;
  lastLogin?: string;
  language?: Language;
  password?: string;
  newsletter?: boolean;
  userSettings?: UserSettings;

  // string type is DEPRECATED, use country type
  country?: string | Country;
}

export interface Register {
  userName: string;
  password: string;
  firstName: string;
  name: string;
  address: string;
  postalCode: string;
  city: string;
  country: string;
  newsletter: boolean;
  languageid: number;
}

export class ScannedValve {
  serial = '';
  type = 0;
  activationCode = '';
}

/** this is for the pwg application */
export class UserImp {
  id = 0;
  firstname = '';
  lastname = '';
  streetNr = '';
  postalCode = '';
  city = '';
  country = '';
  telephone = '';
  email = '';
  activated = false;
  confirmed?: boolean;
  lastLogin = '';
  language: Language = {
    id: 0,
    name: 'English',
    culture: 'en-GB',
    IdName: 'EN',
  };
  userSettings?: UserSettings;

  get fullname(): string {
    return (this.firstname + ' ' + this.lastname).trim();
  }
}

/**
 * UserSettings interface
 */
export interface UserSettings {
  directControlEnabled?: boolean;
}

/**
 * Installer interface
 */
export interface Installer {
  id: number;
  firstname: string;
  lastname: string;
  fullname: string;
  streetNr: string;
  postalCode: string;
  city: string;
  telephone: string;
  email: string;
  vatno: string;
  companyname: string;
  activated: boolean;
  confirmed?: boolean;
  lastLogin: string;
  language: Language;
  password: string;
  newsletter: boolean;

  // string type is DEPRECATED, use country type
  country?: string | Country;
}

/**
 * response from the email exists call
 */
export interface EmailExistsResponse {
  emailExists: boolean;
  passwordExists: boolean;
}
